import {Event} from '@/apiTypes/event';
import {Button} from '@/components/ui/button';
import {Typography} from '@/components/ui/typography';
import {getRegistrationPlatform} from '@/utils/eventDisplayUtils';
import {Link} from '@tanstack/react-router';
import {FC} from 'react';

interface AboutEventProps {
  canClaim: boolean;
  event: Event;
}

export const AboutEvent: FC<AboutEventProps> = ({canClaim, event}) => {
  if (!canClaim || !event) return null;

  const platform = getRegistrationPlatform(event.externalId);
  return (
    <div className="flex flex-col gap-2">
      <Typography level="C3" className="text-neutral-500">
        {platform
          ? `This event is indexed from ${platform}. Registration is managed by the organizer on the third party platform.`
          : `This event listing is indexed from a third party. Check the official event page for the most up-to-date information.`}
      </Typography>
      <Button
        variant="link"
        className="flex items-center gap-1 text-neutral-500 justify-start"
        asChild
      >
        <Link to="/event/$eventId/edit" params={{eventId: event.id}}>
          <Typography level="C3" className="text-neutral-500">
            Are you the organizer? Click here to claim this event.
          </Typography>
        </Link>
      </Button>
    </div>
  );
};
